import React, { memo } from "react";

import cx from "classnames";
import styles from "./Chip.module.scss";

import { CenteredSpan } from "app/components/Common/CenteredSpan";

export interface ChipProps {
  text: string;
  variant: "positive" | "negative" | "neutral";
  icon?: React.ReactNode;
}

export const Chip = memo(({ text, variant, icon }: ChipProps) => {
  return (
    <div
      className={cx(styles.chip, {
        [styles.backgroundPositive]: variant === "positive",
        [styles.backgroundNegative]: variant === "negative",
        [styles.backgroundNeutral]: variant === "neutral",
      })}
    >
      <div
        className={cx(styles.chipContent, {
          [styles.positive]: variant === "positive",
          [styles.negative]: variant === "negative",
          [styles.neutral]: variant === "neutral",
        })}
      >
        {icon}
        <p style={{ margin: 0, lineHeight: 0.6 }}>
          <CenteredSpan>{text}</CenteredSpan>
        </p>
      </div>
    </div>
  );
});
